import React from "react";
import { Button, Modal } from "antd";
import conf from "../config";
import Cookies from "universal-cookie";
import { decode as base64_decode, encode as base64_encode } from "base-64";


const cookies = new Cookies();

const helpPhone = JSON.parse(localStorage.getItem("helpPhone"));
const helpEmail = JSON.parse(localStorage.getItem("helpEmail"));


const HelpModal = ({ show, closeModal }) => {
  const shareToWhatsApp = () => {
   window.open(
  `https://api.whatsapp.com/send/?phone=${helpPhone}&text=&type=phone_number&app_absent=0`
);
  };

  const sendEmail = () => {
    window.open("https://www.google.com/intl/en/gmail/about/");
  };

  return (
    <>
      <Modal
        title="Support"
        open={show}
        onCancel={() => closeModal()}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* {conf.project === "starlingeye" ? ( */}
           {helpEmail && (<Button
              onClick={() => sendEmail()}
              icon={
                <i
                  class="bi bi-envelope"
                  style={{ fontSize: "18px", color: "red" }}
                ></i>
              }
            >
            {/* { this.props.getUserData().helpEmail ? this.props.getUserData().helpEmail : ''} */}
            {helpEmail}
            </Button>
            )}
          

         {helpPhone && (<Button
            icon={
              <i
                class="bi bi-telephone"
                style={{ fontSize: "18px", color: "teal" }}
              ></i>
            }
          >
           {/* { this.props.getUserData().helpPhone ? this.props.getUserData().helpPhone : ''} */}
           {helpPhone}
          </Button>)}

        </div>
        <br />
        <p>
          If you need further assistance, please contact the provided support
          numbers.
        </p>
        {/* <button onClick={handleSignOut}>Sign Out</button> */}
      </Modal>
    </>
  );
};

export default HelpModal;
